import { render, staticRenderFns } from "./preview-template.vue?vue&type=template&id=d534b87a&scoped=true"
import script from "./preview-template.vue?vue&type=script&lang=js"
export * from "./preview-template.vue?vue&type=script&lang=js"
import style0 from "./preview-template.vue?vue&type=style&index=0&id=d534b87a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d534b87a",
  null
  
)

export default component.exports